<script setup lang="ts">
import type { Image } from "~/types/common";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";

interface ArticleSmallCardProps {
  slug: string;
  title?: string;
  image?: Image;
  date?: string;
  time?: number;
}

const props = defineProps<ArticleSmallCardProps>();
</script>

<template>
  <NuxtLinkLocale
    :to="`/education/${props.slug}`"
    class="d-flex align-items-center article-small-card text-decoration-none gap-3"
  >
    <img
      :src="$getStrapiImageSrc(props.image)"
      class="img-fluid br-20 object-fit-cover m-auto d-block"
      style="margin-right: 24px; height: 120px; width: 120px"
      :alt="props.title"
    />
    <div style="width: 100%">
      <div
        class="d-flex justify-content-between article-extra fz-13 fw-500 mb-10"
      >
        <p>{{ props.date }}</p>
        <p>
          <FontAwesomeIcon :icon="faClock" style="margin-right: 3px" />
          {{ props.time }} min
        </p>
      </div>
      <h4>{{ props.title }}</h4>
    </div>
  </NuxtLinkLocale>
</template>
